// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1xQ0i","sendOtp":"AuthorizeToLogin_sendOtp___hHS_"};